import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as apiSimilarRecipes from 'api/aiFunctions/PostSimilarRecipesV1';
import RecipeCard from 'components/desktop/_general/Card/RecipeCard/RecipeCard';
import CardSlider, { SliderCard } from 'components/desktop/_general/CardSlider/CardSlider';
import { Match } from 'components/desktop/_general/Conditional/Match';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import { useApi } from 'hooks/useApi';
import { RootState } from 'reducers/rootReducer';

interface IProps {
	recipeId: string | null;
	recipeText: string | null;
	uiLanguage: string;
}

const SimilarRecipesList = (props: IProps) => {
	const { t } = useTranslation();
	const reduxCurrency = useSelector((state: RootState) => state.currency);
	const reduxValueScope = useSelector((state: RootState) => state.valueScope);

	const [recipes, isLoaded] = useApi(
		[],
		async (recipeId: string | null, recipeText: string | null) => {
			const response = await apiSimilarRecipes.callApi(
				recipeId,
				8,
				recipeText,
				reduxValueScope,
				reduxCurrency
			);
			return response.getOrDefault([]);
		},
		props.recipeId,
		props.recipeText
	);

	const renderContent = () => {
		if (!isLoaded) return <LoadingSpinner />;
		return (
			<Match conditions={[recipes.length === 0]}>
				<div style={{ textAlign: 'center' }}>
					<h2>{t('recipe:NO_SIMILAR_RECIPES_FOUND')}</h2>
				</div>
				<CardSlider
					cards={recipes.map(
						(x) =>
							({
								content: <RecipeCard recipe={x} />,
							}) as SliderCard
					)}
				/>
			</Match>
		);
	};

	return <>{renderContent()}</>;
};

export default SimilarRecipesList;
